//Archivo dedicado al menu de todos los imports de SICPO

//Imports relacionados a SICPO
//-----------Principal-----------
import Plantilla from '@/components/SICPO/Comun/Plantilla.vue'

// Modulo Intranet
import CAdministracionDeContenidos from '@/components/SICPO/Intranet/Contenidos/CAdministracionDeContenidos.vue'
import CPermisosIntranet from '@/components/SICPO/Intranet/Permisos/CPermisos.vue'

// Modulo Pagina web
import AltaDeContenido from '@/components/SICPO/PaginaWeb/AltaDeContenido/AltaContenido.vue'
import CEdicionDeContenido from '@/components/SICPO/PaginaWeb/EdicionDeContenido/CEdicionDeContenido.vue'
import CAdministracionDeSubmenus from '@/components/SICPO/PaginaWeb/Submenus/CAdministracionDeSubmenus.vue'
import CAdministracionDeMenus from '@/components/SICPO/PaginaWeb/Menus/CAdministracionDeMenus.vue'
import CDocumentosDeContenidos from '@/components/SICPO/PaginaWeb/BusquedaDeDocumentos/CDocumentosDeContenidos.vue';
import CPermisosPaginaWeb from '@/components/SICPO/PaginaWeb/Permisos/CPermisos.vue';
import AdministracionAsistentes from '@/components/SICPO/PaginaWeb/ConvocatoriasWeb/AdministracionAsistentes.vue';


// Modulo micrositios
import AltaDeContenidoMicrositio from '@/components/SICPO/Micrositios/AltaContenidoMicrositio.vue';
import EdicionDeContenidoMicrositio from '@/components/SICPO/Micrositios/EdicionContenidoMicrositio.vue';
import AdministradorDeMenuMicrositio from '@/components/SICPO/Micrositios/Menu/CAdministradorDeMenusMicrositios.vue';
import AdministradorDeSubmenuMicrositio from '@/components/SICPO/Micrositios/Menu/CAdministradorDeSubMenusMicrositio.vue';
import AdministradorDeDocumentos from '@/components/SICPO/Micrositios/BusquedaDeDocumentosMicrositios/CAdministradorBusquedaDeDocumentos.vue'
import AdministradorDeComunicados from '@/components/SICPO/Micrositios/AdministracionComunicados.vue';
import PermisosMicrositios from '@/components/SICPO/Micrositios/PermisosMicrositios/PermisosMicrositios.vue';
                                                                                                                                                           
//Se crea la lista de los paths
const SICPO = [
  { 
    name: 'SICPO', 
    path: '/SICPO/', 
    component: Plantilla, 
    meta: { tituloDeLaPagina: "Sistema de Control del Portal", 
    RequiereAutenticacion: true, 
    ValidaSesion: true, 
    ObtenDatos: true, 
    ObtenPermisosDelSistema: true, 
    SistemaQueSeIngreso: 23 }, 
    children: [
      { 
        name: 'CrearContenido', 
        path: 'AltaDeContenido', 
        component: AltaDeContenido, 
        meta: { 
          tituloDeLaPagina: "Alta de contenido página web", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2 
        } 
      },
      { 
        name: 'EditarContenido', 
        path: 'EdicionDeContenido', 
        component: CEdicionDeContenido, 
        meta: { 
          tituloDeLaPagina: "Edicion de contenido página web", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2,
          FuncionId: 6 
        } 
      },
      { 
        name: 'AdministracionDeSubmenusPaginaWeb', 
        path: 'AdministracionDeSubmenusPaginaWeb', 
        component: CAdministracionDeSubmenus, 
        meta: { 
          tituloDeLaPagina: "Administración de submenús página web", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2,
          FuncionId: 7 
        } 
      },
      { 
        name: 'AdministracionDeMenusPaginaWeb', 
        path: 'AdministracionDeMenusPaginaWeb', 
        component: CAdministracionDeMenus, 
        meta: { 
          tituloDeLaPagina: "Administración de menús página web", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2,
          FuncionId: 9 
        } 
      },
      { 
        name: 'AdministracionDePermisosPaginaWeb', 
        path: 'Permisos', 
        component: CPermisosPaginaWeb, 
        meta: { 
          tituloDeLaPagina: "Administracion De Permisos Pagina Web", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2,
          FuncionId:16 
        } 
      },
      { 
        name: 'AdministracionAsistentes', 
        path: 'AdministracionAsistentesConvocatoriasWeb', 
        component: AdministracionAsistentes, 
        meta: { 
          tituloDeLaPagina: "Administracion De Asistentes", 
          RequiereAutenticacion: false, 
          ValidaSesion: false, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2,
          FuncionId:18 
        } 
      },
      { 
        name: 'CrearContenidoMicrositio', 
        path: 'AltaDeContenidoMicrositio', 
        component: AltaDeContenidoMicrositio, 
        meta: { 
          tituloDeLaPagina: "Sistema de Control Micrositios", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2 
        } 
      },
      { 
        name: 'EditarContenidoMicrositio', 
        path: 'EdicionDeContenidoMicrositio', 
        component: EdicionDeContenidoMicrositio, 
        meta: { 
          tituloDeLaPagina: "Sistema de Control Micrositios", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2 
        } 
      },
      { 
        name: 'AdministradorDeMenuMicrositio', 
        path: 'AdministradorDeMenusMicrositios', 
        component: AdministradorDeMenuMicrositio, 
        meta: { 
          tituloDeLaPagina: "Administración de menús Micrositios", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2 
        } 
      },
      { 
        name: 'AdministradorDeSubmenusMicrositio', 
        path: 'AdministradorDeSubmenusMicrositios', 
        component: AdministradorDeSubmenuMicrositio, 
        meta: { 
          tituloDeLaPagina: "Administración de submenús Micrositios", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2 
        } 
      },
      { 
        name: 'BusquedaDeDocumentosContenidos', 
        path: 'BusquedaDeDocumentosContenidos', 
        component: CDocumentosDeContenidos, 
        meta: { 
          tituloDeLaPagina: "Búsqueda de documentos página web", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2,
          FuncionId: 11 
        } 
      },
      { 
        name: 'AdministracionDeContenidosIntranet', 
        path: 'AdministracionDeContenidosIntranet', 
        component: CAdministracionDeContenidos, 
        meta: { 
          tituloDeLaPagina: "Administración de contenidos intranet", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 1,
          FuncionId: 13 
        } 
      },
      { 
        name: 'AdministracionDePermisosIntranet', 
        path: 'AdministracionDePermisosIntranet', 
        component: CPermisosIntranet, 
        meta: { 
          tituloDeLaPagina: "Administración de permisos intranet", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 1,
          FuncionId: 14 
        } 
      },
      { 
        name: 'AdministradorDeDocumentos', 
        path: '/AdministracionDePermisosIntranet', 
        component: AdministradorDeDocumentos, 
        meta: { 
          tituloDeLaPagina: "Busqueda De Archivos Micrositios", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 2, 
        } 
      },
      { 
        name: 'AdministracionComunicadosMicrositios', 
        path: 'AdministracionComunicadosMicrositios', 
        component: AdministradorDeComunicados, 
        meta: { 
          tituloDeLaPagina: "Administracion De Comunicados Micrositios", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 3,
          FuncionId:15 
        } 
      },

      { 
        name: 'PermisosMicrositios', 
        path: 'PermisosMicrositios', 
        component: PermisosMicrositios, 
        meta: { 
          tituloDeLaPagina: "Administración De Permisos Micrositios", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 23,
          ModuloId: 3,
          FuncionId:17 
        } 
      },
    ] 
  }
]

//Se regresa la lista de los paths
export default SICPO;



// WEBPACK FOOTER //
// ./src/router/SICPO.js